import {useMemo} from 'react';
import {Metafield} from '@shopify/hydrogen/storefront-api-types';
import {PartialDeep} from 'type-fest/source/partial-deep';
import {getShopifyProductVariantMetafields} from '../utils/variants';

export type ProductVariantMetafieldKeyType =
  | 'external_shop_id' // namespace: 'shipping'
  | 'productTitle'
  | 'sellerNote'
  | 'sellerShopIsPartner'
  | 'sellerShopProductIsInStock'
  | 'sellerShopProductStockQuantity';

interface UseShopifyProductVariantMetafieldsType {
  metafieldsKeyValue: Readonly<{
    productTitle: string;
    sellerShopIsPartner: boolean;
    sellerShopProductIsInStock: boolean;
    sellerNote: string;
  }>;
}

/*
  Helper utility for resolving Shopify ProductVariant metafields into usable format for UI components.
 */
export default function useShopifyProductVariantMetafields(
  metafields: PartialDeep<Metafield>[],
): UseShopifyProductVariantMetafieldsType {
  return useMemo(
    () => ({
      metafieldsKeyValue: getShopifyProductVariantMetafields(metafields),
    }),
    [metafields],
  );
}
